module.exports = __webpack_public_path__ + "fee994a0201f9f481908ef93d33c3286.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/feet/rollerskates-pinkblue.png
// module id = 2418
// module chunks = 0